// Module
var code = "<h2 id=\"keep-in-mind\">Keep in Mind</h2> <p>If you use a deferment or forbearance, your eligibility may be delayed, or you may be disqualified for any incentive programs that your lenders may offer.</p> ";
// Exports
export default code;